import { IAppState, IRootState } from '@/@types'
import { getEnvVarBoolean, getEnvVarNumber } from '@/helpers/env'
import CONSTANTS from '@/constants'
import { GetterTree } from 'vuex'
import store from '@/store'

const getters: GetterTree<IAppState, IRootState> = {
  getSubscriptionViewSelected: state => {
    return state.subscriptionsViewSelected
  },
  isB2BOfferView: state => {
    return state.subscriptionsViewSelected === CONSTANTS.SHOP_VIEW.B2B_OFFER
  },
  getIsBooGoPromoActive: () => {
    return getEnvVarBoolean('VUE_APP_BOOGO_PROMO_ENABLED')
  },
  isBlackFridayActive: () => {
    return store.getters['featureFlags/isBlackFridayActive']
  },
  isCyberMondayActive: () => {
    return (
      store.getters['featureFlags/isBlackFridayActive'] &&
      store.getters['featureFlags/isCyberMondayActive']
    )
  },
  isPromotionActive() {
    return (
      store.getters['featureFlags/isBlackFridayActive'] ||
      store.getters['featureFlags/isCyberMondayActive'] ||
      store.getters['featureFlags/isTCSPromoEnabled'] ||
      store.getters['featureFlags/isFlashSaleActive'] ||
      store.getters['featureFlags/isSummerSavingsEnabled'] ||
      store.getters['featureFlags/isCerts50percentDiscountEnabled']
    )
  },
  isLeapYearPromoActive: () => {
    const timestamp = getEnvVarNumber('VUE_APP_RUNNING_PROMOTIONS_TIMESTAMP')
    if (!timestamp) {
      return false
    }
    const now = new Date().getTime()
    return now > timestamp
  },
}

export default getters
